import React from 'react';
import Helmet from "react-helmet";
import { Link } from 'react-router-dom';
import '../../App.css';

export const Dates = () => (
  <div>
  <Helmet>
    <title>The 7th International Conference on Soft Computing in Data Science 2023 (scds2023) - Dates</title>
    <meta name="description" content="Important Dates" />
    <meta name="keywords" content="dates, scds, scds 2023, scds2023, uitm, aaec, shah alam, conference" />
  </Helmet>
     <nav aria-label="breadcrumb" style={{ padding: '0.5rem'}}>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link to="/scds2023/home">Home</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Important Dates</li>
      </ol>
    </nav>

    <div className="items-center flex flex-wrap">
        <div className="w-full lg:w-6/12 px-2 ml-auto mr-auto text-center">
            <h1 color="dark">Important Dates</h1>
        </div>
    </div>
    <div style={{ textAlign:'justify', fontFamily: 'Verdana'}}>
       <p>
        1. Final paper submission deadline: <s>31<sup>st</sup> August 2022</s> <a className='blinking' style={{ color:'red'}}><b>15<sup>th</sup> October 2022</b></a><br/>
        2. Notification of paper acceptance: 5<sup>th</sup> November 2022<br/>
        3. Submission of 'Camera-Ready' paper and 'Copyright' form deadline: 20<sup>th</sup> November 2022<br/>
        4. Registration deadline: 15<sup>th</sup> November 2022<br/>
        5. Conference dates: 24<sup>th</sup> - 25<sup>th</sup> January 2023<br/>
    </p>
    </div>
   
  </div>
)